import { render, staticRenderFns } from "./PlayerList.vue?vue&type=template&id=46c8db95&"
import script from "./PlayerList.vue?vue&type=script&lang=ts&"
export * from "./PlayerList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports